<div class="card-outline">
  <div class="product-info-column">
    <div class="product-info-row">
      <div class="product-image-column">
        <app-product-card-image
          [isOnline]="panAppState.online$ | async"
          [imageThumbnail]="product?.imageThumbnail"
          [productNumber]="product?.productNumber"
          [clickable]="clickable && !product?.notFound"
          (productImageClickEmitter)="productImageClick()"
        ></app-product-card-image>
      </div>
      <div class="product-information-column">
        <app-product-card-information
          [brand]="product?.summary?.brand"
          [description]="product?.summary?.productDescTxtl"
          [productNumber]="product?.productNumber"
          [salesPackSize]="product?.summary?.salesPackSize"
          [note]="
            product?.item
              ? product?.item?.note
              : product?.masterListItem?.referenceComment
          "
          [showNote]="showNotes"
          [notFound]="product?.notFound"
          [customerProductNumber]="product?.customerProductNumber"
          [showPowerReview]="false"
          [pricePerPortion]="product?.pricePerPortion"
          (itemNoteClickEmitter)="itemNoteClick()"
          (productDescriptionClickEmitter)="productClick()"
          [truncateAmount]="
            platformService.platformType ===
            platformService.platformEnum.desktop
              ? 53
              : platformService.platformType ===
                  platformService.platformEnum.mobile
                ? 30
                : 25
          "
          [clickable]="clickable"
          [isGuestUser]="isGuestUser"
        >
        </app-product-card-information>
      </div>
    </div>
    <div
      *ngIf="mode === productCardModes.defaultSearch && powerReviewRollupModel"
      class="power-review-row"
    >
      <app-power-custom-review-rating-stars
        [powerReviewRollupModel]="powerReviewRollupModel"
        [ratingStarsCSSEnum]="ratingStarsCSSEnum.ORIGINAL_PRODUCT"
        [ratingAverageCSSEnum]="ratingAverageCSSEnum.ORIGINAL_PRODUCT"
      ></app-power-custom-review-rating-stars>
    </div>
    <div *ngIf="product?.productTags?.length > 0" class="product-tags-row">
      <app-usf-product-tag-list
        [tagList]="product?.productTags"
        [infoIconEnabled]="false"
        [allTagsClickable]="true"
        [product]="transformProductToProductDetail()"
        [maxTags]="5"
      >
      </app-usf-product-tag-list>
    </div>
  </div>
  <div class="ordering-column">
    <div
      [class.not-list-management-ordering]="
        mode !== productCardModes.listManagement
      "
      class="order-price-ellipsis-row"
    >
      <div class="order-price-column">
        <app-product-card-ordering
          [productSummary]="product?.summary"
          [pricing]="product?.pricing"
          [casesOrdered]="product?.casesOrdered"
          [eachesOrdered]="product?.eachesOrdered"
          [isOrderable]="product?.orderable"
          [isOnline]="panAppState.online$ | async"
          [platformType]="this.platformService?.platformType"
          [index]="index"
          [listId]="listId"
          [hotkeyIds]="product?.hotkeyIds"
          [pricingDisabled]="pricingDisabled"
          [mode]="mode"
          [notFound]="product?.notFound"
          [hideQuantityBoxes]="product?.hideQuantityBoxes"
          [isSplitCard]="false"
          (quantityUpdateEmitter)="changeQuantityHandler($event)"
          (quantityElementEmitter)="quantityInputUpdate($event)"
          (mouseover)="handleMouseOver($event)"
          (mouseleave)="handleMouseLeave()"
          [isGuestUser]="isGuestUser"
        >
        </app-product-card-ordering>
      </div>
      <div class="ellipsis-column" *ngIf="mode !== productCardModes.modifyVS">
        <app-product-card-ellipsis
          *ngIf="
            mode !== productCardModes.tmNoteDetails &&
            mode !== productCardModes.addToInventory &&
            mode !== productCardModes.productNumberSearch
          "
          [notFound]="
            (orderService.restrictNavigationForCurrentOrder$ | async) ||
            product?.notFound
          "
          (ellipsisClickEmitter)="ellipsisClick($event)"
          [isGuestUser]="isGuestUser"
        >
        </app-product-card-ellipsis>
      </div>
    </div>
    <div
      class="promotions-line-number-row"
      *ngIf="showPromotionsAndLineNumber()"
    >
      <div class="promotions-column">
        <app-product-card-promotions-banner
          *ngIf="
            mode !== productCardModes.listManagement &&
            mode !== productCardModes.addToInventory &&
            product?.promotionDetails
          "
          [offerBenefitDesc]="product?.promotionDetails?.offerBenefitDesc"
          [productNumber]="product?.summary?.productNumber"
          (bannerClickEmitter)="promotionClick($event)"
        >
        </app-product-card-promotions-banner>
      </div>
      <div class="line-number-column">
        <app-product-card-line-number
          *ngIf="
            mode === productCardModes.listDetail ||
            mode === productCardModes.listManagement ||
            mode === productCardModes.productNumberSearch
          "
          [sequenceNumber]="sequenceNumber"
          [isListManagement]="mode === productCardModes.listManagement"
          (resequenceProductEmitter)="resequenceProduct($event)"
        >
        </app-product-card-line-number>
      </div>
    </div>
    <!-- Confirm Unusual Quantities -->
    <div *ngIf="showConfirmQuantityButton">
      <ion-button
        class="usf-fill-green-button confirm-qty-button"
        (click)="confirmUnusualQuantity(product.productNumber)"
      >
        {{ 'i18n.orderPage.confirmQuantities' | translate }}
      </ion-button>
    </div>
  </div>
</div>
